import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { DataSourceRequestState } from '@progress/kendo-data-query';
import { PatientService } from '@services/patient.service';
import { ProviderDetailsReportEntity, ReportsService } from '@services/reports.service';
import { Subject } from 'rxjs';
import { distinct, mergeMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-provider-details',
  templateUrl: './provider-details.component.html',
  styleUrls: ['./provider-details.component.less'],
})
export class ProviderDetailsComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  unsub = new Subject<any>();
  providerDetails: ProviderDetailsReportEntity[] = [];

  private _gridState: DataSourceRequestState;
  @Input() set gridState(value: DataSourceRequestState) {
    // Don't update the pagination state
    if (this._gridState) {
      value.skip = this._gridState.skip;
      value.take = this._gridState.take;
    }
    value.sort = value.sort?.filter((sort) => sort.field !== 'providerName');
    this._gridState = value;
  }
  get gridState(): DataSourceRequestState {
    return this._gridState;
  }

  @Input() serviceProviderId: string;

  constructor(private router: Router, private reportsService: ReportsService, private patientService: PatientService) {}

  ngOnInit() {
    this.getReportData();
  }

  private getReportData() {
    this.reportsService.reportsModelUpdated
      .pipe(
        distinct(),
        tap(() => (this.loading = true)),
        mergeMap(() => this.reportsService.getProvidersReportDetails(this.serviceProviderId, this.gridState)),
        tap(() => (this.loading = false))
      )
      .subscribe((gridDataResult) => (this.providerDetails = gridDataResult));
  }

  navigateToPatientInvoice(patientId: number, invoiceId: number) {
    this.patientService
      .getPatientById(patientId)
      .pipe(takeUntil(this.unsub))
      .subscribe((patient: any) => {
        this.patientService.patientPanelPatient = patient;
        this.router.navigate([
          '/reports',
          {
            outlets: {
              'action-panel': [
                'patient',
                patientId + '_patientprofiletab',
                'patienttabs',
                'patientaccounttab',
                'invoice',
                invoiceId,
              ],
            },
          },
        ]);
      });
  }

  navigateToPatientAccountTab(patientId: number) {
    this.patientService
      .getPatientById(patientId)
      .pipe(takeUntil(this.unsub))
      .subscribe((patient: any) => {
        this.patientService.patientPanelPatient = patient;
        this.router.navigate([
          '/reports',
          {
            outlets: {
              'action-panel': [
                'patient',
                patientId + '_patientprofiletab',
                'patienttabs',
                'patientaccounttab',
                'overview',
              ],
            },
          },
        ]);
      });
  }

  pageChange(event: PageChangeEvent) {
    this.gridState.skip = event.skip;
    this.getReportData();
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
